import { css } from 'lit';

export const styles = css`
	:host {
		display: flex;
		flex-direction: column;
	}
`;
